var _path, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 183,
    viewBox: "0 0 116 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.2671 157.567H42.72V82.8598C42.72 79.5315 42.7841 75.8188 42.9111 71.7205C43.0393 67.6234 43.1663 63.975 43.2945 60.774C41.6351 62.6946 40.1015 64.3593 38.6973 65.7671C37.4201 67.176 36.0799 68.4552 34.6745 69.6083L19.1569 82.4755L0 58.8545L46.935 20.4446H80.2682V157.567H80.2671Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 86.956,
    cy: 91.5144,
    rx: 28.4279,
    ry: 91.1366,
    fill: "url(#paint0_radial_526_1707)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_526_1707",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.956 91.5144) rotate(90) scale(91.1366 28.4279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090A14",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneVector);
export default __webpack_public_path__ + "static/media/one-vector.5e4ec1d9845d141b90c6b1dcb8538697.svg";
export { ForwardRef as ReactComponent };